import {TfiEmail} from "react-icons/tfi";
import {IoLocationOutline} from "react-icons/io5";
import {FaFacebook, FaInstagram, FaLinkedinIn, FaTwitter} from "react-icons/fa";
import {Link} from 'react-router-dom';
import './style.css';
import logo from '../../images/logo.png'
import {useState} from "react";
import { FaBars } from 'react-icons/fa';

export default function HeaderNavigation() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };
    return (
        <header className="w-full fixed z-20 bg-white/50 top-0 ">
            <nav
                className="hidden md:flex md:flex-1  h-12 bg-white border-b">
                <div className="w-full flex flex-1 px-18 justify-around my-2 gap-4">
                    <div className="flex justify-start gap-4">
                        <Link to="mailto://goldphasemedicalfoundation@gmail.com"
                              className="flex flex-row gap-2 items-center justify-center text-slate-700 text-sm font-playfair-display hover:text-yellow-600">
                            <TfiEmail/> goldphasemedicalfoundation@gmail.com
                        </Link>
                        <Link to="/"
                              className="flex flex-row gap-2 items-center justify-center text-slate-700 text-sm font-playfair-display hover:text-yellow-600">
                            <IoLocationOutline/> Find our Location
                        </Link>
                    </div>
                    <div className="flex flex-shrink-0 items-center justify-center gap-4">
                        <Link to="/"
                              className="items-center justify-center text-slate-700 text-sm font-playfair-display hover:text-yellow-600">
                            <FaFacebook/>
                        </Link>
                        <Link to="/"
                              className="items-center justify-center text-slate-700 text-sm font-playfair-display hover:text-yellow-600">
                            <FaTwitter/>
                        </Link>
                        <Link to="https://www.instagram.com/goldphasemedicalfoundation"
                              className="items-center justify-center text-slate-700 text-sm font-playfair-display hover:text-yellow-600">
                            <FaInstagram/>
                        </Link>
                        <Link to="/"
                              className=" items-center justify-center text-slate-700 text-sm font-playfair-display hover:text-yellow-600">
                            <FaLinkedinIn/>
                        </Link>
                    </div>
                </div>
            </nav>
            <nav
                className="navbar navbar-expand-lg navbar-light w-full h-18 bg-white md:bg-white/50 justify-between items-center border-b">
                <div className="w-full flex flex-1 px-18 justify-around mb-2 pt-2 gap-4">
                    <Link className="navbar-brand justify-start inline-flex items-center" to="/">
                        <img src={logo} alt="Logo" className="flex  h-14"/>
                        <div className="ml-2 flex flex-col">
                            <p className="text-xl font-extrabold font-bowlby-one uppercase text-slate-700"> Gold
                                Phase</p>
                            <p className="font-bold text-md font-roboto text-gray-500"> Medical
                                Foundation</p>
                        </div>
                    </Link>

                    <button
                        className="md:hidden text-slate-700 focus:outline-none text-2xl"
                        onClick={toggleMenu}
                    >
                        <FaBars className="text-yellow-600"/>
                    </button>
                    <div
                        className={`hidden md:flex md:items-center md:space-x-4`}>
                        <Link to="/"
                              onClick={() => setIsOpen(false)}
                              className="text-slate-700 hover:text-yellow-600 px-3 py-2 rounded-md text-sm font-bold uppercase font-roboto">Home</Link>
                        <Link to="/mission"
                              onClick={() => setIsOpen(false)}
                              className="text-slate-700 hover:text-yellow-600 px-3 py-2 rounded-md text-sm font-bold uppercase">Mission</Link>
                        <Link to="/leaders"
                              onClick={() => setIsOpen(false)}
                              className="text-slate-700 hover:text-yellow-600 px-3 py-2 rounded-md text-sm font-bold uppercase">Leaders</Link>
                        <Link to="/gallery"
                              onClick={() => setIsOpen(false)}
                              className="text-slate-700 hover:text-yellow-600 px-3 py-2 rounded-md text-sm font-bold uppercase">Gallery</Link>
                        <Link to="/blog"
                              onClick={() => setIsOpen(false)}
                              className="text-slate-700 hover:text-yellow-600 px-3 py-2 rounded-md text-sm font-bold uppercase">Blog</Link>

                    </div>

                </div>
            </nav>
            <div
                className={`${isOpen ? 'flex flex-1 flex-col gap-2 text-center' : 'hidden'} md:hidden md:items-center md:space-x-4 w-full shadow-2xl py-2 bg-white `}>
                <Link to="/"
                      onClick={() => setIsOpen(false)}
                      className="text-slate-700 hover:text-yellow-600 px-3 py-2 rounded-md text-sm font-medium uppercase font-roboto">Home</Link>
                <Link to="/mission"
                      onClick={() => setIsOpen(false)}
                      className="text-slate-700 hover:text-yellow-600 px-3 py-2 rounded-md text-sm font-medium uppercase">Mission</Link>
                <Link to="/leaders"
                      onClick={() => setIsOpen(false)}
                      className="text-slate-700 hover:text-yellow-600 px-3 py-2 rounded-md text-sm font-medium uppercase">Leaders</Link>
                <Link to="/gallery"
                      onClick={() => setIsOpen(false)}
                      className="text-slate-700 hover:text-yellow-600 px-3 py-2 rounded-md text-sm font-medium uppercase">Gallery</Link>
                <Link to="/blog"
                      onClick={() => setIsOpen(false)}
                      className="text-slate-700 hover:text-yellow-600 px-3 py-2 rounded-md text-sm font-medium uppercase">Blog</Link>

            </div>

        </header>
    )
}